import React from 'react'
import Navbar from './Navbar'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
const Home = () => {
  // const accessToken = Cookies.get('accessToken');
  // const navigate = useNavigate();
  // if (!accessToken) {
  //   navigate("/login");
  // }
  return (
    <div>
      <div>
        <Navbar />
      </div>
      <div style={{marginTop : "250px"}}>
        <h1 className='flex justify-center text-3xl'>Home</h1>
      </div>
    </div>
  )
}

export default Home